(() => {
  const init = (section) => {
    if (!section || section.dataset.trustInitialized === 'true') return;
    section.dataset.trustInitialized = 'true';

    const motionEnabled = section.dataset.motion === 'true'
      && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!motionEnabled) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        section.classList.add('is-visible');
        observer.unobserve(section);
      });
    }, { threshold: .15 });

    observer.observe(section);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-cosmo-trust]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
